import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  getLocalValue,
  IsSmallScreen,
  LoacalVariables,
  updateMainHeader,
} from "../../../commonFunctions/CommonFunctions";
import PermissionDenied from "../../../commonFunctions/PermissionDenied";
import {
  AllPermissions,
  getPermissions,
  IPermission,
} from "../../../commonFunctions/PermissionManger";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import WSMobileDataGridAdvanced, {
  IOrderColumns,
} from "../../../Components/DataGrid/WSMobileDataGridAdvanced";
import ConfirmationPopup, {
  IMethodAction,
} from "../../../Components/Confirmation/Confirmation";
import { useDispatch } from "react-redux";
import { resetDataComponent } from "../../../StateManagement/actions";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import WSDataGridNew from "../../../Components/DataGrid/WSDataGridNew";
import WSButton from "../../../Components/Button/WSButton";
import WSFilterButtonGroup from "../../../Components/Filter/WSFilterButtonGroup";
import AddIcon from "@mui/icons-material/Add";
import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";

export const BookingList: React.FC<any> = React.memo((props) => {
  const navigate = useNavigate();
  const isMobile = IsSmallScreen();
  const dispatch = useDispatch();
  // AllPermissions.getInstance();
  //const { add,edit,remove, view} =AllPermissions.getCallPermission;
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [action, setAction] = useState<IMethodAction>("DELETE");
  const [apiUrl, setApiUrl] = useState<any>(null);
  const [bodyData, setBodyData] = useState<any>(null);
  const { showMessage } = useSnackbar();

  const { add, edit, remove } = getPermissions("bookings"); // role permissions for this page

  const filters = ["All Records"];
  const [selectedFilter, setSelectedFilter] = useState(filters[0]);

  const [productSource, setProductSource] = useState<any>({
    url: "Booking/search",
    page: 1,
    pageSize: 10,
    filter: [],
    sort: [{
      field:'BookingDate',
      direction:'desc'
    }],
  });

  const handleFilter = (value: any) => {
    const updatedSource: any = {
      url: "Booking/search",
      page: 1,
      pageSize: 10,
      filter: [],
      sort: [
        {
          field: "updatedAt",
          direction: "desc",
        },
      ],
    };
    // extend here for more filters when needed
    switch (value) {
      default:
        break;
    }
    setProductSource({ ...updatedSource });
  };

  useEffect(() => {
    updateMainHeader("Booking ");
    breadCrumbsStore.updateBreadCrumbs([{ "Booking List": "/booking/list" }]);
  }, []);

  /**
   * Edit function
   * @param action
   * @param row
   */
  const handleAction = async (action: string, row: any) => {
    if (action === "Cancel") {
      setAction("POST");
      setApiUrl(
        `Booking/cancel/${row?.id}?cancelledBy=${getLocalValue(
          LoacalVariables.UserId
        )}`
      );
      setSelectedId(null); // Set the ID of the row to be deleted
      setPopupOpen(true);
      setBodyData({});
    }
  };

  const columns: IColumns[] = [
    {
      header: "Customer",
      fieldName: "customerName",
      type: "default",
      //  sortable: true
    },
    {
      header: "Doctor",
      fieldName: "doctorName",
      type: "default",
    },
    {
      header: "Phone",
      fieldName: "phoneNumber",
      tooltip: true,
      isHide: isMobile,
      type: "default",
    },
    {
      header: "Booked On",
      fieldName: "bookingDate",
      isHide: isMobile,
      type: "date",
    },
    {
      header: "Time",
      fieldName: "bookingTime",
      isHide: isMobile,
      type: "time",
    },
    {
      header: "Status",
      fieldName: "status",
      isHide: isMobile,
      type: "status",
    },

    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: [edit && "Cancel"].filter(Boolean),
      actionCallback: (action, row) => handleAction(action, row),
      hideSelectedActions: {
        fieldToHide: [
          {
            field: "status",
            hideValue: ["Cancelled"],
            hideActions: ["Cancel"],
          },
        ],
      },
    },
  ];
  const mobColumns: IOrderColumns[] = [
    {
      header: "Full Name",
      fieldName: "fullName",
      type: "default",
      labelSx: { fontWeight: "bold" },
    },
    {
      header: "Email",
      fieldName: "email",
      tooltip: true,
      type: "default",
    },
    {
      header: "Phone",
      fieldName: "phoneNumber",
      tooltip: true,

      type: "default",
    },
    {
      header: "Created On",
      fieldName: "createdAt",
      isBoderRadious: true,
      type: "date",
    },
    {
      header: "Updated On",
      fieldName: "updatedAt",
      isBoderRadious: true,
      type: "date",
    },

    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: [edit && "Edit", edit && "Approve"].filter(Boolean),
      actionCallback: (action, row) => handleAction(action, row),
    },
  ];
  const handleClick = () => {
    navigate("/doctor/add");
  };

  const transFormData = (data: any) => {
    if (data) {
      data.map((item: any) => {
        item.customerName = `${item?.customer?.name}`;
        item.phoneNumber = `${item?.customer?.phoneNumber}`;
        item.doctorName = `${item?.doctor?.user?.name}`;
      });
      return data;
    }
  };
  const handleConfirm = (response: any) => {
    dispatch(resetDataComponent("bookingListGrid"));
    showMessage(response?.message, response?.success ? "success" : "error");
  };
  const handleAddClick = () => {
    navigate(`/booking/list/book`)
  }
  return (
    <Grid p={3}>
      <Grid container spacing={2}>
        <Grid item sm={9}>
          <WSFilterButtonGroup
            options={filters}
            selected={selectedFilter}
            onChange={(value) => {
              setSelectedFilter(value);
              handleFilter(value);
            }}
          />
        </Grid>
        <Grid item sm={3} display="flex" justifyContent={"flex-end"}>
          <WSButton
            id="btnBook"
            label="Book Now"
            startIcon={<AddIcon />}
            onClick={handleAddClick}

            sx={{
              borderRadius: "999px", // pill shape
              backgroundColor: "#098963!important", // green background
              textTransform: "none", // prevent uppercase
              fontWeight: 500,
              height: "35px!important",
              fontSize: "0.875rem!important",
              paddingX: 3,
              paddingY: 1,
              "&:hover": {
                backgroundColor: "#087654!important",
              },
            }}
          />
        </Grid>
        <Grid item xs={12}>
          {productSource && (
            <WSDataGridNew
              id="bookingListGrid"
              title="Bookings"
              columns={columns}
              source={productSource}
              transFormData={transFormData}
              searchBox={{
                fieldName:
                  "phoneNumber"
              }}
              showpagination={true}
              gridHeaderSx={{
                backgroundColor: "whitesmoke",
                border: "1px solid whitesmoke",
              }}
            />
          )}
          {apiUrl !== null && (
            <ConfirmationPopup
              apiUrl={apiUrl}
              id={selectedId!}
              confirmMessage="Are you sure you want to continue?"
              open={isPopupOpen}
              onClose={() => setPopupOpen(false)}
              onConfirm={handleConfirm}
              type={action}
              bodyData={bodyData}
            />
          )}
        </Grid>
      </Grid>
    </Grid>
  );
});
